import type { AuthUser, AuthProfile } from "@/contexts/AuthContext";
import ProfileInfo from "./ProfileInfo";
import SecuritySettings from "./SecuritySettings";

type ProfileSettingsProps = {
  user: AuthUser | null;
  profile: AuthProfile | null;
};

const ProfileSettings = ({ user, profile }: ProfileSettingsProps) => {
  return (
    <div className="space-y-8">
      <ProfileInfo user={user} profile={profile} />
      <SecuritySettings />
    </div>
  );
};

export default ProfileSettings;
